module.exports = __webpack_public_path__ + "img/kailei_logo.66dc9abf.png";